import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import Spinner from '@atlaskit/spinner';
import { SHORTCUT_MENU_ITEM_BASE_WIDTH } from '../../../constants.tsx';

export const Fallback = () => (
	<Box xcss={wrapperStyles}>
		<Spinner size="medium" />
	</Box>
);

const wrapperStyles = xcss({
	height: '240px',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${SHORTCUT_MENU_ITEM_BASE_WIDTH}px`,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
});
